<script setup>
const { removeConsent } = useCookieConsent();
const { $_, $auth } = useNuxtApp()
const config = useRuntimeConfig()
const cookies = () => {
    removeConsent();
};
</script>
<template>
    <footer class="border-t-2 border-gray-300 bg-white">
        <div class="wrapper">
            <div class="itemsWrapper text-sm text-gray-600">
                <NuxtLink to="/dashboard">
                    <img src="~/assets/img/logo-icon.svg" alt="Econit logo" />
                </NuxtLink>

                    <a href="#">{{ $_('footer.help_centre') }}</a>
                    <p class="md:pl-4">({{ $_('footer.contact_number') }})</p>
                    <a :href="'mailto:' + $_('footer.contact_email')"
                        class="text-green underline hover:no-underline md:pl-4">
                        {{ $_('footer.contact_email') }}
                    </a>
                <button @click="cookies">
                    {{ $_('footer.manage_cookies') }}
                </button>
            </div>

            <div>
                <p class="text-xs text-gray-600 md:text-sm">{{ $_('footer.app_version') }} {{ config.public.APP_VERSION
                }}</p>
            </div>
        </div>
    </footer>
</template>
<style scoped>
footer {
    padding: 24px var(--default-whitespace);
}
.wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.itemsWrapper{
    display: flex;
    align-items: center;
    gap: 1rem;
}
.moreWrapper{
    flex-direction: column;
}
@media screen and (max-width: 1280px) {
    footer {
        padding-bottom: 100px;
    }
    .itemsWrapper{
        flex-direction: column;
    }
    .wrapper{
        flex-direction: column;
        gap: 1rem;
    }
}
</style>